import { __assign } from "tslib";
import React from 'react';
import { StyledTooltip } from './styled';
export var Tooltip = React.forwardRef(function (props, ref) {
    return (React.createElement(StyledTooltip, __assign({ color: props.color, componentsProps: {
            tooltip: {
                sx: function (theme) { return ({
                    bgcolor: props.color
                        ? theme.palette[props.color].light
                        : theme.palette.greySecondary[600],
                    '& .MuiTooltip-arrow': {
                        color: props.color
                            ? theme.palette[props.color].light
                            : theme.palette.greySecondary[600],
                    },
                }); },
            },
        } }, props, { ref: ref }), props.children));
});
Tooltip.displayName = "Tooltip";
//# sourceMappingURL=tooltip.js.map